import * as React from "react";
import { NumberParam, StringParam, useQueryParams } from "use-query-params";
import { GameFilter } from "../../common/GameFilter";

export const CardFilterForm = () => {
    const [query, setQuery] = useQueryParams({
        g: StringParam,
        se: NumberParam,
        s: NumberParam,
        l: StringParam,
        page: NumberParam,
    });
    const setGameId = (ref) => {
        setQuery({ g: ref, se: undefined, s: undefined, page: 1 });
    };

    return (
        <>
            <GameFilter selected={query.g} setSelected={setGameId} />
        </>
    );
};
